import { defineStudy } from './registry';
import { novavaxBoosterScreeningQuestions } from '../../../data/pre-screener-config/NovavaxBoosterScreener';
import { novavaxBoosterEligibleZipCodes } from '../../../data/vaccine-study-zipcodes';

const COMMON_QUESTION_IDS = ["age_eligibility", "past_vaccine_study_participation"];

/**
 * Novavax COVID-19 Booster Study (50-64)
 * VCOVIV420
 * Priority: 7
 * Target: Healthy adults aged 50-64
 * Zipcodes: 476 across multiple states
 */
export const novavaxCovidBoosterStudy = defineStudy({
  id: "novavax-covid-booster",
  name: "Novavax COVID-19 Booster Study for Healthy Adults",
  trialId: "VCOVIV420",
  priority: 7,
  eligibleZipCodes: Array.from(novavaxBoosterEligibleZipCodes),
  questions: novavaxBoosterScreeningQuestions,
  commonQuestionIds: COMMON_QUESTION_IDS,
  // Required common answer values (age 50-64)
  commonAnswerRequirements: {
    age_eligibility: ["50_to_64"],
  },
});
